import styled from "@emotion/styled";
import { Box, ListItem, Stack, Typography } from "@mui/material";
import React, { useState } from "react";
import WrapperContainer from "./WrapperContainer";
import { ResponsiveStyles } from "./responsiveDimension";
import FaceBookSvg from "../../assets/svg/facebook.svg";
import InstagramSvg from "../../assets/svg/instagram.svg";
import LinkedinSvg from "../../assets/svg/linkedin.svg";
// import Twittersvg from "../../assets/svg/twitter.svg";
import QRScanner from "../../assets/image/QRScanner.png";
import AppleStore from "../../assets/image/applestore.png";
import Googlepay from "../../assets/image/googlepay.png";
import TextFieldBox from "./TextField";
import SendIcon from "@mui/icons-material/Send";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Link as ScrollLink } from "react-scroll";
import { RoutesPath } from "../../routes/RoutesPath";

const Footer = () => {
  const navigation = useNavigate();
  const location = useLocation().pathname;
  const Heading = ({ title }) => {
    return (
      <Typography fontSize={16} fontWeight={700} color="white">
        {title}
      </Typography>
    );
  };
  const Text = ({ title, subTitle }) => {
    return (
      <TextName>
        {subTitle && <span style={{ fontWeight: 700 }}>{subTitle} : </span>}
        {title}
      </TextName>
    );
  };
  const scanner = [
    { src: QRScanner, alt: "QRScanner", icon: Googlepay },
    { src: QRScanner, alt: "QRScanner", icon: AppleStore },
  ];

  const linkslist = [
    { name: "Home", navigate: "home" },
    { name: "Features", navigate: "feature" },
    { name: "Pricing", navigate: "plans" },
    { name: "FAQ", navigate: "faq" },
    { name: "Contact", navigate: "contact" },
  ];
  const contactDetails = [
    {
      type: "Address",
      value: "13/06 TDTA School street, Tenkasi",
    },
    {
      type: "Email",
      value: "mcxpremier@gmail.com",
    },
    // {
    //   type: "Selvakumar",
    //   value: "+91 9940303865",
    // },
  ];
  const socialmediaIcons = [
    { src: FaceBookSvg, alt: "Facebook" },
    { src: InstagramSvg, alt: "Instagram" },
    // { src: Twittersvg, alt: "Twitter" },
    { src: LinkedinSvg, alt: "LinkedIn" },
  ];
  const policy = [
    { name: "Terms & Condition", navigate: RoutesPath.TERMSANDCONDITION },
    { name: "Refund Policy", navigate: RoutesPath.REFUNDPOLICY },
    { name: "Privacy Policy", navigate: RoutesPath.PRIVACYPOLICY },
    { name: "Contact Us", navigate: RoutesPath.CONTACTUS },
  ];
  const handleNavigation = (navigateTo) => {
    if (["home", "plans", "feature", "faq", "contact"].includes(navigateTo)) {
      document.getElementById(navigateTo)?.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    } else if (navigateTo && location !== navigateTo) {
      navigation(navigateTo);
    }
    // handleClose(); // Close the drawer after navigation
  };
  const handlePolicyNavigate = (navigateTo) => {
    // console.log(navigateTo,']]]]');

    navigation(navigateTo);
  };
  const [email, setEmail] = useState();
  return (
    <Container id="contact">
      <WrapperContainer>
        <SubContainer>
          <ContentContainer width={"30%"}>
            <Heading title={"Our Community"} />
            <Text
              title={"Here you’ll find regular market updates tips & stories "}
            />
            <Stack
              sx={{
                width: 300,
                bgcolor: "white",
                display: "flex",
                flexDirection: "row",
                justifyContent: "center",
                mt: 4,
              }}
            >
              <TextFieldBox
                name="email"
                value={email}
                placeholder="E-mail Address"
                handleChange={(e) => setEmail(e.target.value)}
                icon={<SendIcon />}
                // onIconClick={handleIconClick}
              />
              <Stack
                sx={{
                  backgroundColor: "rgba(232, 177, 0, 1)",
                  display: "flex",
                  justifyContent: "space-evenly",
                  padding: 1,
                }}
              >
                <SendIcon color="white" />
              </Stack>
            </Stack>
            {/* <IconsContainer>
              {socialmediaIcons.map((icon, index) => (
                <SvgIcon key={index}>
                  <img src={icon.src} alt={icon.alt} />
                </SvgIcon>
              ))}
            </IconsContainer>
             */}
          </ContentContainer>

          {/* <ContentContainer width={"20%"}>
            <Heading title={"Download App"} />
            <Stack display={"flex"} flexDirection={"row"} gap={2}>
              {scanner.map((icon, index) => (
                <Stack key={index} gap={2}>
                  <img src={icon.icon} alt="" />
                </Stack>
              ))}
            </Stack>
          </ContentContainer> */}

          <ContentContainer width={"20%"}>
            {/* {linkslist.map((link, index) => (
              <ListItem
                key={index}
                button
                onClick={() => handleNavigation(link.navigate)}
                sx={{ paddingLeft: "0", paddingTop: "0", paddingBottom: "0" }}
              >
                <Text
                  title={link.name}
                  component={
                    ["plans", "feature", "faq", "contact"].includes(
                      link.navigate
                    )
                      ? ScrollLink
                      : Link
                  }
                  to={link.navigate}
                  smooth={true}
                  offset={-70}
                />
              </ListItem>
            ))} */}
            <MenuItem>
              <Box display={"flex"} flexDirection={"column"} gap={1}>
                <Heading title={"Links"} />
                {linkslist.map((value, index) => (
                  <MenuText
                    component={location === "/" ? ScrollLink : Link}
                    to={location === "/" ? value.navigate : "/"}
                    key={index}
                    smooth={value.navigate === "plans"}
                    offset={-70}
                  >
                    {value.name}
                  </MenuText>
                ))}
              </Box>
            </MenuItem>
          </ContentContainer>

          <ContentContainer width={"25%"}>
            <Heading title={"Policy"} />
            {policy.map((link, index) => (
              <Stack
                onClick={() => {
                  console.log("clicked");

                  handlePolicyNavigate(link.navigate);
                }}
              >
                <Text key={index} title={link.name} />
              </Stack>
            ))}
          </ContentContainer>

          <ContentContainer width={"20%"}>
            <Heading title={"Contact us"} />
            <Typography style={{ color: "white" }}>STOCK VIEW POINT</Typography>
            {contactDetails.map((link, index) => (
              <Text key={index} title={link.value} subTitle={link.type} />
            ))}
            {/* <IconsContainer>
              {socialmediaIcons.map((icon, index) => (
                <SvgIcon key={index}>
                  <img src={icon.src} alt={icon.alt} />
                </SvgIcon>
              ))}
            </IconsContainer> */}
          </ContentContainer>
        </SubContainer>
      </WrapperContainer>
      <AllRights>
        © 2025 Copyright @ Stock View Point. All rights reserved.
      </AllRights>
    </Container>
  );
};

const Container = styled(Box)(() => ({
  backgroundColor: "rgba(15, 13, 29, 1)",
  padding: "50px 0px",
}));
const SubContainer = styled(Box)(() => ({
  display: "flex",
  flexWrap: "wrap",
}));
const AllRights = styled(Typography)(() => ({
  textAlign: "center",
  width: "100%",
  color: "white",
  borderTop: "1px solid white",
  paddingTop: 20,
  marginTop: 20,
}));
const ContentContainer = styled(Box)(({ width }) => ({
  display: "flex",
  flexWrap: "wrap",
  flexDirection: "column",
  gap: 10,
  padding: 10,
  ...ResponsiveStyles({
    width: {
      xs: "100%",
      md: "50%",
      lg: width,
    },
  }),
}));

const IconsContainer = styled(Box)(() => ({
  display: "flex",
  flexWrap: "wrap",
  gap: 10,
  // backgroundColor:'red'
}));
const TextName = styled(Box)(() => ({
  fontSize: 16,
  fontWeight: 400,
  color: "white",
  cursor: "pointer",
  width: "300px",
}));

const SvgIcon = styled(Box)(() => ({
  // backgroundColor: "white",
  // width: 40,
  // height: 40,
  // borderRadius: 50,
  // display: "flex",
  // alignItems: "center",
  // justifyContent: "center",
  // transition: "all .2s linear",
  cursor: "pointer",
  "&:hover": {
    transform: "scale(1.1)",
    transition: "all .2s linear",
  },
}));
const MenuItem = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  ...ResponsiveStyles({
    width: { xs: "20%", md: "35%" },
    justifyContent: { xs: "end", md: "space-between" },
  }),
}));
const MenuText = styled(Typography)(({ theme }) => ({
  fontSize: 16,
  fontWeight: 400,
  color: "white",
  cursor: "pointer",
}));

export default Footer;
